import React, { FC, useRef } from 'react';
import { useActionsDispatcher } from '../../../../ActionsDispatcher';
import { SectionHeader } from '../../SectionHeader';
import styles from './MyWidgets.scss';
import { TextLabel } from '@wix/wix-base-ui';
import { MyWidgetThumb } from './WidgetThumb/MyWidgetThumb';

import type { MyWidgetsProps, PresetItemProps } from './MyWidgets.types';
import type { DragItemRect } from '../../../../..';
import type { MyWidgetsItem } from '@wix/add-panel-common';

export const MyWidgets: FC<MyWidgetsProps> = ({ section }) => (
  <div className={styles.app} data-hook={`widget-app-${section.appId}`}>
    <SectionHeader headerText={section.title} title={section.title} disableInfoIcon shouldTranslate={false} />

    {section.props.items.map((widget: MyWidgetsItem) => (
      <PresetItem key={`${widget.id}_${widget.presetId}`} preset={widget} shouldShowTitle={true} />
    ))}
  </div>
);

const PresetItem: FC<PresetItemProps> = ({ preset, shouldShowTitle }) => {
  const previewRef = useRef<HTMLDivElement>(null);
  const { dispatchStartMyWidgetDrag } = useActionsDispatcher();

  const handleMouseDown = (event: React.MouseEvent) => {
    if (!previewRef.current || !preset.size) {
      return;
    }
    const rect = getPreviewDimensions(previewRef.current);
    dispatchStartMyWidgetDrag({
      event,
      sectionName: preset.id,
      dragItemData: {
        item: {
          itemId: preset.id,
          onDrop: preset.onItemDrop,
          structure: {
            layout: preset.size,
          },
        },
        rect,
      },
    });
  };

  const getPreviewDimensions = (element: Element): DragItemRect => {
    const { left, top, width, height } = element.getBoundingClientRect();

    return { left, top, width, height };
  };

  return (
    <div
      className={styles.presetItem}
      ref={previewRef}
      onMouseDown={handleMouseDown}
      onClick={preset.onItemClick}
      data-hook={`preset-item-${preset.id}`}
    >
      {shouldShowTitle && (
        <TextLabel
          value={preset.desc || ''}
          className={styles.presetItemName}
          enableEllipsis={true}
          shouldTranslate={false}
          type="T02"
        />
      )}
      <MyWidgetThumb thumb={preset.image} presetName={preset.desc} />
    </div>
  );
};
